import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Box from "@material-ui/core/Box";

export default function Links() {
  const style = {
    display: "block",
    padding: "10px 10px",
    fontSize: "15px",
    color: "red",
    width: "100%",
    height: "100%",
  };

  const redirect = () => {
    return <Redirect to="/login" />;
  };

  const isAuth = localStorage.getItem("isAuth") === "true";
  const [open, setOpen] = useState(false);
  const styleMenu = {
    fontSize: "13px",
    fontWeight: "200px",
    height: "100%",
    marginRight: "30%",
    width: "70%",
    position: "fixed",
    zIndex: "1",
    top: 0,
    left: 0,
    backgroundColor: "rgba(256,256,256,0.9)",
    overflow: "hidden",
    paddingTop: "20px",
    transition: "all 2s ease-out",
    color: "rgba(0,0,0,0.5)",
    paddingLeft: "20px",
    paddingRight: "20px",
    shadowColor: "black",
  };
  const li = {
    borderBottom: "solid 1px rgb(0 0 0 / 0.15)",
    marginBottom: "2px",
    padding: "10px 0px",
    color: "black",
  };
  return (
    <div className="mainnav">
      <div className="container ">
        <div className="menu-wrap">
          <nav className="navbar navbar-expand-lg">
            {open ? (
              <Box boxShadow={4} style={styleMenu} className="mobile">
                <ul style={{ width: "100%", color: "black" }}>
                  <Link to="/">
                    <li
                      style={li}
                      onClick={() => {
                        setOpen(!open);
                      }}
                    >
                      Home
                    </li>
                  </Link>
                  <Link to="/about-us">
                    <li
                      style={li}
                      onClick={() => {
                        setOpen(!open);
                      }}
                    >
                      About 121five.com
                    </li>
                  </Link>
                  <Link to="/search-news-and-features">
                    <li
                      style={li}
                      onClick={() => {
                        setOpen(!open);
                      }}
                    >
                      Search News & Features
                    </li>
                  </Link>
                  <Link to="/gallery">
                    <li
                      style={li}
                      onClick={() => {
                        setOpen(!open);
                      }}
                    >
                      Photographer Galleries
                    </li>
                  </Link>
                  {/* <li
                    style={li}
                    onClick={() => {
                      setOpen(!open);
                    }}
                  >
                    Translate
                  </li> */}
                  <Link to="/contact-us">
                    <li
                      style={li}
                      onClick={() => {
                        setOpen(!open);
                      }}
                    >
                      Contact Information
                    </li>
                  </Link>
                  <li
                    style={li}
                    onClick={() => {
                      setOpen(!open);
                    }}
                  >
                    AeroVents.com Calendar
                  </li>

                  {isAuth ? (
                    <Link to={{ pathname: "/dashboard" }} onClick={redirect}>
                      <li
                        style={li}
                        onClick={() => {
                          setOpen(!open);
                        }}
                      >
                        Sponsor Portal
                      </li>
                    </Link>
                  ) : (
                    <Link to={{ pathname: "/login" }} onClick={redirect}>
                      <li
                        style={li}
                        onClick={() => {
                          setOpen(!open);
                        }}
                      >
                        Sponsor Portal
                      </li>
                    </Link>
                  )}
                </ul>
              </Box>
            ) : (
              ""
            )}
            <div className="nav-toggle">
              <div className="mobile" onClick={() => setOpen(!open)}>
                {open ? (
                  <CloseIcon fontSize="large" color="primary" />
                ) : (
                  <MenuIcon fontSize="large" color="primary" />
                )}
              </div>
            </div>
            <div className="bar-collapse d-flex justify-content-center align-items-center">
              <ul className="navbar-nav d-flex justify-content-center">
                <Link to="/">
                  <li className="nav-item ">
                    <button
                      className="border-0 bg-transparent text-white"
                      style={style}
                    >
                      <span className="buttonHover">Home</span>
                    </button>
                  </li>
                </Link>
                <Link to="/about-us">
                  <li className="nav-item">
                    <button
                      className="border-0 bg-transparent text-white"
                      style={style}
                    >
                      <span className="buttonHover">About 121five.com</span>
                    </button>
                  </li>
                </Link>
                <Link to="/search-news-and-features">
                  <li className="nav-item">
                    <button
                      className="border-0 bg-transparent text-white"
                      style={style}
                    >
                      <span className="buttonHover">
                        Search News & Features
                      </span>
                    </button>
                  </li>
                </Link>
                <Link to="/gallery">
                  <li className="nav-item">
                    <button
                      className="border-0 bg-transparent text-white"
                      style={style}
                    >
                      <span className="buttonHover">
                        Photographer Galleries
                      </span>
                    </button>
                  </li>
                </Link>
                {/* <li className="nav-item">
                  <a
                    className="nav-link"
                    style={style}
                    href="http://www.worldlingo.com/products_services/worldlingo_translator.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Translate
                  </a>
                </li> */}
                <Link to="/contact-us">
                  <li className="nav-item">
                    <button
                      className="border-0 bg-transparent text-white"
                      style={style}
                    >
                      <span className="buttonHover">Contact Information</span>
                    </button>
                  </li>
                </Link>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    style={style}
                    href="https://aerovents.com/body.shtml"
                    target="_blank"
                    rel="noreferrer"
                  >
                    AeroVents.com Calendar
                  </a>
                </li>

                {isAuth ? (
                  <Link to={{ pathname: "/dashboard" }} onClick={redirect}>
                    <li>
                      <button
                        className="border-0 bg-transparent text-white"
                        style={style}
                      >
                        <span className="buttonHover">Sponsor Portal</span>
                      </button>
                    </li>
                  </Link>
                ) : (
                  <Link to={{ pathname: "/login" }} onClick={redirect}>
                    <li>
                      <button
                        className="border-0 bg-transparent text-white"
                        style={style}
                      >
                        <span className="buttonHover">Sponsor Portal</span>
                      </button>
                    </li>
                  </Link>
                )}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}
